import { useContext } from 'react'
import { DesignVersionContext } from './DesignVersionProvider'

export const useDesignVersion = () => {
    const ctx = useContext(DesignVersionContext)

    if (!ctx) {
        throw new Error(
            'useDesignVersion must be used inside DesignVersionProvider'
        )
    }

    return ctx
}
